const ConditionalWrapper = ({ children, condition, wrapper }) => (
  condition ? wrapper(children) : children
);

export default ConditionalWrapper;
